import ProductBox from '../ProductBox/ProductBox';
import './ProductBoxSlider.css';

function ProductBoxSlider({
    category,
    products,
    showScrollbar,
    visible,
    disabled,
    clientName,
    taxMultiplier,
    taxLabel,
    productBoxDesign,
    discountBackgroundColor,
    discountLabelColor,
    exclusivePriceLabelColor,
    exclusivePriceIcon,
    offerBackgroundColor,
    offerLabelColor,
    offerLabel,
    offerIcon,
    infoTagBorderColor,
    infoTagBackgroundColor,
    infoTagLabelColor,
    sellerLabelColor,
    mainSellerIcon,
    taxDisclaimerBackgroundColor,
    taxDisclaimerLabelColor,
    showPulseEffect,
    pulseEffectColor,
    showSeller,
    showDelivery,
    showRating,
    showTags,
    showInfoTagOnImage,
    infoTagLabel,
    infoTagProperty,
    onClick
}) {
    const renderProducts = () => {
        return products.map((product, index) => (
            <ProductBox
                key={`similar-product-${product.id}`}
                idPrefix='similar-product'
                index={index}
                category={category}
                product={product}
                showSku={true}
                showIcons={false}
                active={false}
                showBorder={false}
                clientName={clientName}
                design={productBoxDesign}
                _3dIcon={undefined}
                isFeatured={false}
                shouldDraw3D={false}
                shouldDrawGallery={false}
                taxMultiplier={taxMultiplier}
                taxLabel={taxLabel}
                discountBackgroundColor={discountBackgroundColor}
                discountLabelColor={discountLabelColor}
                exclusivePriceLabelColor={exclusivePriceLabelColor}
                exclusivePriceIcon={exclusivePriceIcon}
                offerBackgroundColor={offerBackgroundColor}
                offerLabelColor={offerLabelColor}
                offerLabel={offerLabel}
                offerIcon={offerIcon}
                deliveryIcon={undefined}
                deliveryLabelColor={undefined}
                deliveryBackgroundColor={undefined}
                freeDeliveryIcon={undefined}
                freeDeliveryLabelColor={undefined}
                freeDeliveryBackgroundColor={undefined}
                pickupIcon={undefined}
                pickupLabelColor={undefined}
                pickupBackgroundColor={undefined}
                infoTagBorderColor={infoTagBorderColor}
                infoTagBackgroundColor={infoTagBackgroundColor}
                infoTagLabelColor={infoTagLabelColor}
                sellerLabelColor={sellerLabelColor}
                mainSellerIcon={mainSellerIcon}
                taxDisclaimerBackgroundColor={taxDisclaimerBackgroundColor}
                taxDisclaimerLabelColor={taxDisclaimerLabelColor}
                featuredDefaultIcon={undefined}
                featuredDefaultLabel={undefined}
                featuredDefaultMediaWidthPercentage={undefined}
                featuredWidthMultiplier={undefined}
                featuredBackgroundColor={undefined}
                featuredLabelColor={undefined}
                showPulseEffect={showPulseEffect}
                pulseEffectColor={pulseEffectColor}
                showSeller={showSeller}
                showDelivery={showDelivery}
                showRating={showRating}
                showTags={showTags}
                showInfoTagOnImage={showInfoTagOnImage}
                infoTagLabel={infoTagLabel}
                infoTagProperty={infoTagProperty}
                visible={visible}
                disabled={disabled}
                onClick={onClick}
            />
        ));
    };

    return (
        <div className={`product-box-slider ${showScrollbar ? 'scrollbar' : 'no-scrollbar'}`}>
            {renderProducts()}
        </div>
    );
}

export default ProductBoxSlider;